import { render, staticRenderFns } from "./SubpageNotificationUsageAlert.vue?vue&type=template&id=3711d124&"
import script from "./SubpageNotificationUsageAlert.vue?vue&type=script&lang=js&"
export * from "./SubpageNotificationUsageAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3711d124')) {
      api.createRecord('3711d124', component.options)
    } else {
      api.reload('3711d124', component.options)
    }
    module.hot.accept("./SubpageNotificationUsageAlert.vue?vue&type=template&id=3711d124&", function () {
      api.rerender('3711d124', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/notifications/SubpageNotificationUsageAlert.vue"
export default component.exports